import { useState } from 'react';
import { useBlockedUsersCount } from '../../hooks/useBlockedUsersQuery';
import { BlockedUsersModal } from './BlockedUsersModal';
import { Skeleton } from '../ui/Skeleton';

export function BlockedUsersSection() {
  const { data: totalBlocked, isLoading, isError } = useBlockedUsersCount();
  const [showModal, setShowModal] = useState(false);

  return (
    <>
      <div className="pt-4 border-t border-white/[0.06]">
        <div className="flex items-center justify-between">
          <div>
            <div className="text-white font-medium">Blocked Users</div>
            <div className="text-sm text-slate-400">
              {totalBlocked != null
                ? `You have blocked ${totalBlocked} user${totalBlocked !== 1 ? 's' : ''}`
                : isError
                  ? 'Unable to load blocked users right now.'
                  : isLoading
                    ? <Skeleton className="h-4 w-40 inline-block" />
                    : null}
            </div>
          </div>
          <button
            onClick={() => setShowModal(true)}
            className="px-4 py-2 bg-[#2A2F36] hover:bg-[#3A3F46] text-white rounded-lg transition-colors font-medium"
          >
            Manage
          </button>
        </div>
      </div>

      {showModal && <BlockedUsersModal isOpen={showModal} onClose={() => setShowModal(false)} />}
    </>
  );
}
